__turbopack_context__.v({
  "in": "RollingNumber-module__bs06lW__in",
  "rise": "RollingNumber-module__bs06lW__rise",
  "roll": "RollingNumber-module__bs06lW__roll",
});
